// Embed page type — renders a pre-built, same-origin mini-app inside an iframe.
//
// The app is served by nginx at `/<uuid>/` (e.g. /bid/). Because it is
// same-origin with the ERP, it shares localStorage. The embedded app reads its
// JWT from `localStorage.access_token`, so we mirror the Tim-box access token
// there before the iframe mounts and keep it fresh while mounted.
import { useEffect, useState } from "react";
import { useAuth } from "../../shared/stores/auth";

type Program = { id: number; name: string; uuid: string | null };

export default function EmbedView({ program }: { program: Program }) {
  const token = useAuth(s => s.accessToken);

  // Mirror the token BEFORE the iframe mounts (lazy initializer runs during the
  // first render, synchronously, before children are committed to the DOM).
  useState(() => {
    if (token) localStorage.setItem("access_token", token);
    return null;
  });

  // Keep it current if the access token rotates while mounted.
  useEffect(() => {
    if (token) localStorage.setItem("access_token", token);
  }, [token]);

  if (!program.uuid) {
    return (
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", color: "var(--text-3)", fontSize: 13 }}>
        임베드할 앱 경로(UUID)가 없습니다.
      </div>
    );
  }

  return (
    <iframe
      title={program.name}
      // ?v cache-buster: escapes any stale browser-cached index.html for the
      // embedded SPA (its index is served no-cache, but a previously-cached copy
      // can stick around via heuristic freshness). Bump when redeploying the app.
      src={`/${encodeURIComponent(program.uuid)}/?v=2026092101`}
      style={{ flex: 1, width: "100%", border: "none", background: "#0b0b12" }}
      // 큐랩 같은 앱이 이 PC 의 스피커 목록을 읽고 고를 수 있게 한다.
      // (장치 "이름"은 마이크 권한이 있어야 브라우저가 알려 준다 — 녹음에 쓰지는 않는다)
      allow="clipboard-write; microphone; speaker-selection; autoplay; fullscreen"
    />
  );
}
